module.exports = __webpack_public_path__ + "static/media/Grandeur_Hospitality.6b5edf9b.png";